const DEFAULT_ZOOM_ON_CITY = 10;
const DEFAULT_ZOOM = 5;
const DEBOUNCE_TIME = 1000;

const Z_INDEX_ULTIMATE = 3;
const Z_INDEX_HOVER = 2;
const Z_INDEX_DEFAULT = 1;

const MAP_ID = 'd014e286f2890fa667ac6589';

const MAP_EVENT_NAMES = {
  clicked_show_on_map: 'clicked_show_on_map',
  map_displayed: 'map_displayed',
  map_show_list: 'map_show_list',
  map_show_list_displayed: 'map_show_list_displayed',
  map_list_property_click: 'map_list_property_click',
  map_applied_filter: 'map_applied_filter',
  map_choosed_city: 'map_choosed_city',
  map_clicked_home_icon: 'map_clicked_home_icon',
  map_clicked_property: 'map_clicked_property',
  map_view_deal: 'map_view_deal',
  map_clicked_close: 'map_clicked_close',
  map_mobile_click_filter: 'map_mobile_click_filter',
  map_mobile_filters: 'map_mobile_filters',
  map_mobile_clicked_filters_close: 'map_mobile_clicked_filters_close',
}

export { DEFAULT_ZOOM_ON_CITY, DEFAULT_ZOOM, DEBOUNCE_TIME, Z_INDEX_ULTIMATE, Z_INDEX_HOVER, Z_INDEX_DEFAULT, MAP_ID, MAP_EVENT_NAMES };